import { Alert, Button, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { httpService } from "../../httpService";

import { useAppUser } from "../../contexts/AppUserContext";
import { Link } from "react-router-dom";

function DashboardPage() {
  const [currentPosting, setCurrentPosting] = useState(null);
  const [loading, setLoading] = useState(false);
  const [printing, setPrinting] = useState(false);
  const { user } = useAppUser();
  const getData = async () => {
    setLoading(true);
    const { data, error } = await httpService("myposting");

    if (data) {
      //console.log(data);
      setCurrentPosting(data);
    }
    if (error) {
    }
    setLoading(false);
  };

  const downloadLetter = async () => {
    setPrinting(true);
    const { data, error } = await httpService("downloadletter", {
      responseType: "blob",
    });
    if (data) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `letter.pdf`);

      document.body.appendChild(link);
      link.click();

      link.remove();
      console.log(data);
    }
    if (error) {
      console.error(error);
    }
    setPrinting(false);
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <div>
      <div className="d-sm-block d-lg-none">
        <div className="container p-3 mb-3">
          <div
            className="rounded text-white d-flex p-3 align-items-center"
            style={{ backgroundColor: "#22577A", minHeight: "25vh" }}
          >
            <div>
              <div className="mb-3">
                <Typography gutterBottom>Welcome Back,</Typography>
                <Typography
                  fontWeight={700}
                  variant="h4"
                  className="text-uppercase"
                >
                  {user.firstName} {user.lastName}
                </Typography>
                <Typography variant="overline">{user.licenseNumber}</Typography>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-none d-lg-block">
        <div
          className="mb-3 text-white d-flex align-items-center"
          style={{ backgroundColor: "#22577A", minHeight: "25vh" }}
        >
          <div className="container">
            <Typography gutterBottom>Welcome Back,</Typography>
            <Typography
              fontWeight={700}
              variant="h4"
              className="text-uppercase"
            >
              {user.firstName} {user.lastName}
            </Typography>
            <Typography variant="overline">{user.licenseNumber}</Typography>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="col-lg-6">
          <Typography
            color="GrayText"
            gutterBottom
            variant="h5"
            fontWeight={700}
          >
            Current Posting
          </Typography>
          {loading ? (
            <>
              <CircularProgress size={20} />
            </>
          ) : (
            <>
              {currentPosting && currentPosting.released ? (
                <div className="alert alert-light border-0">
                  <Typography gutterBottom>
                    You have been nominated for this examination
                  </Typography>
                  <Typography fontWeight={700} textTransform={"uppercase"}>
                    {currentPosting.examination.title}
                  </Typography>
                  <hr />
                  <Typography>You have been posted to</Typography>
                  <Typography fontWeight={700} textTransform={"uppercase"}>
                    {currentPosting.school.school} {currentPosting.school.state}
                  </Typography>
                  <hr />
                  <div className="text-end">
                    {currentPosting.letterUrl ? (
                      <Button
                        href={currentPosting.letterUrl}
                        variant="contained"
                        color="success"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        download letter
                      </Button>
                    ) : (
                      <Alert severity="warning">
                        Your letter has not been generated yet
                      </Alert>
                    )}
                    {/* <a
                      href={currentPosting.letterUrl}
                      download
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn  btn-success"
                    >
                      DOWNLOAD LETTER
                    </a> */}
                    <br />
                    <div className="mt-4">
                      <Button
                        component={Link}
                        to={`/confirmposting/${currentPosting._id}`}
                      >
                        confirm or decline this posting
                      </Button>
                    </div>

                    {/* <LoadingButton
                      // onClick={downloadLetter}
                      onClick={() =>
                        window.open(currentPosting.letterUrl, "_blank")
                      }
                      color="success"
                      startIcon={<PictureAsPdf />}
                      loading={printing}
                      loadingPosition="start"
                    >
                      Download Letter
                    </LoadingButton> */}
                  </div>
                </div>
              ) : (
                <div className="alert alert-danger border-0">
                  <Typography>
                    You are not posted for the current examination
                  </Typography>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default DashboardPage;
